// extracted by css-extract-rspack-plugin
export default {"cls1":"DebugPage-cls1_ZEb","cls2":"DebugPage-cls2_3Fn DebugPage-cls1_ZEb"};